__webpack_require__.p = "/lugx/";